// extracted by mini-css-extract-plugin
export default {"orderItemSummary":"G0b7014 G9245dd G81a5ae"};